export enum TransactionHashType {
  STRIPE = 'stripe',
  MOONPAY = 'moonpay',
  GALACHAIN = 'galachain',
  ETHEREUM = 'ethereum',
  UNKOWN = 'unknown',
}

export const transactionTypeByHash = (hash: string) => {
  if (/pi_.{0,24}$/.test(hash)) {
    return TransactionHashType.STRIPE;
  } else if (
    /^(?:\{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\}{0,1})$/.test(
      hash,
    )
  ) {
    return TransactionHashType.MOONPAY;
  } else if (/^0x([A-Fa-f0-9]{64})$/.test(hash)) {
    return TransactionHashType.ETHEREUM;
  } else if (/([A-Fa-f0-9]{64})$/.test(hash)) {
    return TransactionHashType.GALACHAIN;
  }
};
